import React, { useState, useEffect, Suspense } from 'react';
import Header from './components/Header';
import Navigation from './components/Navigation';
import CookieConsent from './components/CookieConsent';

// Lazy load sektioner
const History = React.lazy(() => import('./components/sections/History'));
const Attractions = React.lazy(() => import('./components/sections/Attractions'));
const Routes = React.lazy(() => import('./components/sections/Routes'));
const Flora = React.lazy(() => import('./components/sections/Flora'));
const Fauna = React.lazy(() => import('./components/sections/Fauna'));
const Info = React.lazy(() => import('./components/sections/Info'));

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('history');

  useEffect(() => {
    if (window.location.pathname === '/signalbakken') {
      window.history.replaceState({}, '', '/');
    }
  }, []);

  const handleSectionChange = (section: string) => {
    setActiveSection(section);
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateHome = () => {
    setActiveSection('history');
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderSection = () => {
    switch (activeSection) {
      case 'history':
        return <History />;
      case 'attractions':
        return <Attractions />;
      case 'routes':
        return <Routes />;
      case 'flora':
        return <Flora />;
      case 'fauna':
        return <Fauna />;
      case 'info':
        return <Info />;
      default:
        return <History />;
    }
  };

  return (
    <div className="min-h-screen bg-green-50">
      <Header 
        isOpen={isMenuOpen} 
        setIsOpen={setIsMenuOpen}
        onNavigateHome={handleNavigateHome}
      />
      <Navigation 
        isOpen={isMenuOpen} 
        activeSection={activeSection}
        onSectionChange={handleSectionChange}
      />
      <main className="container mx-auto px-4 pt-24 pb-8">
        <Suspense fallback={<div>Loading...</div>}>
          {renderSection()}
        </Suspense>
      </main>
      <CookieConsent />
    </div>
  );
}

export default App;